import { Box, Flex, Text, useClipboard, Button, Input } from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { toastTip } from "@/components/ui/toast";
import { useI18n } from "@/hooks/useI18n";
import QRCode from "qrcode.react";
import {
  postVerifyPaymentPasssword,
  postCreateGaSecret,
  postGaReset,
} from "@/pages/bindGA/api.js";
import MiliCodeInput from "@/components/ui/mili-codeinput/mili-codeinput.component";
import { throttle } from "lodash";
import { verifyCodeVaild } from "@/utils/regexp";
import { updateUserInfo, updateRegisterMsg } from "@/state/user/reducer";
import { useAppDispatch } from "@/state/hooks";
import { postLoginFunc } from "@/pages/login/api.js";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "@/state/hooks";
import ModalComponent from "@/components/ui/modal";
import { useMedia } from "@/hooks/useMedia";
import { postUserCreateFunc } from "@/pages/register/api.js";
import StepDesc from "@/pages/register/components/StepDesc.js";
import { getPostLoginRedirect } from "./postLoginRedirect";

const PaymentPassModal = ({ show, onClose, password, emailInfo, login }) => {
  const [verifyCode, setVerifyCode] = useState("");
  const [codeError, setCodeError] = useState(false);

  const verifyCodeChange = (e) => {
    const value = e.target.value;
    if (codeError) {
      setCodeError(false);
    }
    setVerifyCode(value);
  };

  const { t } = useI18n();
  const { isMobile } = useMedia();

  const verifyPaymentPassword = async () => {
    if (!verifyCodeVaild(verifyCode)) return;

    const res = await postVerifyPaymentPasssword({
      email: emailInfo,
      login_password: password,
      payment_password: verifyCode,
    });
    console.log("verifyPaymentPassword", res);

    if (res?.code === 0 && res?.data?.ok) {
      await login(verifyCode);
      onClose();
    } else {
      setCodeError(true);
    }
  };

  useEffect(() => {
    if (!show) {
      setVerifyCode("");
      setCodeError(false);
    }
  }, [show]);

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "400px" : "calc(100% - 30px)" }}
    >
      <Box p={["30px 30px"]}>
        <Flex flexDirection={"column"} alignItems={"center"} gap="30px">
          <Flex w={"100%"} align={"center"} justifyContent={"center"}>
            <Text w="100%" fontSize="16px" color="t.100" fontWeight={"500"}>
              {t("MomfHqvEpMWlhryCXUf")}
            </Text>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={onClose}
              style={{ cursor: "pointer" }}
            >
              <path
                d="M8.36353 8.36328L15.6366 15.6364"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.36362 15.6364L15.6367 8.36328"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Flex>

          <Flex w="100%" flexDirection={"column"} gap="40px">
            <Flex flexDirection={"column"} gap="10px">
              <Text fontSize="14px" color="t.100">
                {t("irXsKkZagNKDlvCyhKYK")}
              </Text>
              <Input
                h="44px"
                borderRadius={"12px"}
                placeholder={t("KKbVbDLheqewlSvBE")}
                fontSize="12px"
                type="email"
                w={["100%"]}
                _placeholder={{ color: "t.50" }}
                onChange={verifyCodeChange}
                isInvalid={codeError}
                bg={codeError ? "red.50" : "none"}
                errorBorderColor="red.100"
              />
            </Flex>

            <Flex w={"100%"} justifyContent={"center"}>
              <Button
                borderRadius={"20px"}
                w="100%"
                h="44px"
                fontSize="14px"
                color="#fff"
                // mt="50px"
                onClick={verifyPaymentPassword}
                _hover={{ bg: verifyCode?.length === 6 ? "blue.80" : "t,50" }}
                cursor={verifyCode?.length === 6 ? "pointer" : "not-allowed"}
                bg={verifyCode?.length === 6 ? "blue.100" : "t.50"}
              >
                {t("AQrCocFqoKoYieUnT")}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </ModalComponent>
  );
};

const LoginAndRegisterBindGa = (props) => {
  const { t } = useI18n();
  const {
    emailInfo,
    password,
    needVerifyPaymentPassword,
    setRegisterStep,
    isModifyGa,
  } = props;
  const { onCopy, setValue } = useClipboard("");
  const [qrCode, setQrCode] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [ga, setGa] = useState("");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);
  const [nextError, setNextError] = useState(false);
  const [showPaymentPassModal, setShowPaymentPassModal] = useState(false);

  const registerMsg = useAppSelector((state) => state.user.registerMsg);
  const registerPhone = useAppSelector((state) => state.user.registerPhone);

  const passWordInputRef = useRef(null);
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const { isMobile } = useMedia();

  const passwordInput = (val) => {
    if (val) {
      setCode(val);
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  const login = async (paymentPassword) => {
    let body = {
      email: emailInfo,
      loginPassword: password,
      ga_code: code,
    };

    if (needVerifyPaymentPassword && paymentPassword) {
      body.payment_password = paymentPassword;
    }

    const loginRes = await postLoginFunc(body);

    if (loginRes.code !== 0) {
      toastTip(loginRes?.message, { type: "error" });
    } else if (loginRes.code === 0) {
      localStorage.setItem("token", loginRes.data.token);
      dispatch(updateUserInfo({ userInfo: loginRes.data.user }));

      window.location.href = getPostLoginRedirect();
    }
  };

  const submitLogin = throttle(async () => {
    if (!verifyCodeVaild(code)) return;

    if (isModifyGa) {
      const modifyGaRes = await postGaReset({ code });
      console.log("modifyGaRes", modifyGaRes);
      if (modifyGaRes?.code === 0) {
        toastTip(t("MThZOMtyoBvwpuodWEa"), { type: "success" });
        setTimeout(() => {
          navigator(-1);
        }, 1000);
      }

      return;
    }

    if (setRegisterStep) {
      const registerRes = await postUserCreateFunc({
        email: registerMsg.email,
        loginPassword: registerMsg.pwd,
        paymentPassword: registerMsg.payPwd,
        phone_code: registerPhone.phoneCode,
        phone_number: registerPhone.phoneNumber,
        ga_code: code,
      });
      if (registerRes.data) {
        const user = registerRes.data;
        localStorage.setItem("token", user.token);
        // dispatch(
        //   updateRegisterMsg({
        //     registerMsg: {
        //       rePwd,
        //     },
        //   })
        // );
        setRegisterStep("SUCCESS");
      }
    } else {
      if (needVerifyPaymentPassword) {
        setShowPaymentPassModal(true);
      } else {
        login();
      }
    }
  }, 2000);

  const createGa = async () => {
    const res = await postCreateGaSecret({ email: emailInfo });
    if (res.code === 0) {
      setGa(res.data.secret);
      setValue(res.data.secret);
      setQrCode(res?.data?.qr_string);
    }
  };
  useEffect(() => {
    if (!emailInfo) return;
    createGa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Flex justifyContent={"center"} mt={["50px", "135px"]} mb="50px">
        <Box w={["80%", "400px"]}>
          {/* tip */}
          {!setRegisterStep && !isModifyGa && (
            <Flex
              w={["100%", "400px"]}
              align="center"
              gap="10px"
              padding="10px"
              borderRadius="12px"
              backgroundColor="#EDEFFC"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0008 3.66699C7.40915 3.66699 3.66748 7.40866 3.66748 12.0003C3.66748 16.592 7.40915 20.3337 12.0008 20.3337C16.5925 20.3337 20.3341 16.592 20.3341 12.0003C20.3341 7.40866 16.5925 3.66699 12.0008 3.66699ZM11.3758 8.66699C11.3758 8.32532 11.6591 8.04199 12.0008 8.04199C12.3425 8.04199 12.6258 8.32532 12.6258 8.66699V12.8337C12.6258 13.1753 12.3425 13.4587 12.0008 13.4587C11.6591 13.4587 11.3758 13.1753 11.3758 12.8337V8.66699ZM12.7675 15.6503C12.7258 15.7587 12.6675 15.842 12.5925 15.9253C12.5091 16.0003 12.4175 16.0587 12.3175 16.1003C12.2175 16.142 12.1091 16.167 12.0008 16.167C11.8925 16.167 11.7841 16.142 11.6841 16.1003C11.5841 16.0587 11.4925 16.0003 11.4091 15.9253C11.3341 15.842 11.2758 15.7587 11.2341 15.6503C11.1925 15.5503 11.1675 15.442 11.1675 15.3337C11.1675 15.2253 11.1925 15.117 11.2341 15.017C11.2758 14.917 11.3341 14.8253 11.4091 14.742C11.4925 14.667 11.5841 14.6087 11.6841 14.567C11.8841 14.4837 12.1175 14.4837 12.3175 14.567C12.4175 14.6087 12.5091 14.667 12.5925 14.742C12.6675 14.8253 12.7258 14.917 12.7675 15.017C12.8091 15.117 12.8341 15.2253 12.8341 15.3337C12.8341 15.442 12.8091 15.5503 12.7675 15.6503Z"
                  fill="#333BF5"
                />
              </svg>
              <Text fontSize="12px" fontWeight={"400"} color="#333BF5">
                {t("atlghZvDeMzQOGOAFC")}
              </Text>
            </Flex>
          )}

          {!setRegisterStep && (
            <Flex justifyContent={"center"} mt="20px">
              <img src="../wwwsite/images/GoogleAuth.svg" alt="ga" />
              <Text fontSize="32px" fontWeight={"600"} color="t.100" ml="10px">
                {t("nSdDtaHzknwZAXJHzrGP")}
              </Text>
            </Flex>
          )}

          {setRegisterStep && (
            <Text fontSize="32px" fontWeight={"600"} color="t.100">
              {t("wjeaGDSVTuLLjJGehN")}
            </Text>
          )}
          {setRegisterStep && <StepDesc active={4} />}

          {/* <Text
            mt="40px"
            fontSize="16px"
            color="t.100"
            mb="10px"
            fontWeight={"500"}
          >
            {t("HfjMmDJQuBZXqFJUw")}
          </Text>
          <Text fontSize="14px" color="t.80" mb="10px" fontWeight={"500"}>
            {t("SVTrmHtEOHifBpgPNCY")}
          </Text>
          <Box
            w={[isMobile ? "100%" : "10%", "400px"]}
            h="47px"
            bg="rgba(32, 26, 85, 0.05)"
            borderRadius={"12px"}
            fontSize="12px"
            color="t.100"
            padding="0 10px"
            mt="5px"
            lineHeight={"47px"}
          >
            <Flex justifyContent={"space-between"} alignItems={"center"}>
              <Text>{ga}</Text>
              <Box
                cursor={"pointer"}
                onClick={() => {
                  onCopy();
                  toastTip(t("gXbirwakdsaUKBglwK"));
                }}
              >
                <img src="../wwwsite/images/copy.svg" alt="copy" />
              </Box>
            </Flex>
          </Box> */}
          <Text
            mt="40px"
            fontSize="16px"
            color="t.100"
            mb="10px"
            fontWeight={"500"}
          >
            {t("gbkxEEkMTXuhYuUCZTJ")}
          </Text>
          <Text
            mt="10px"
            fontSize="14px"
            color="#7B7C8F"
            mb="10px"
            fontWeight={"400"}
          >
            {t("tUbfJJpmJpRKpGFxLo")}
          </Text>
          <Box
            w="200px"
            h="200px"
            border="1px"
            borderColor="#000"
            p="10px"
            borderRadius="12px"
            mx={"auto"}
            mt={"20px"}
          >
            <QRCode value={qrCode} size={180} id="qrCode" />
          </Box>

          <Text
            mt="40px"
            fontSize="16px"
            color="t.100"
            mb="10px"
            fontWeight={"500"}
          >
            {t("mKIsjRtEzgllkCJZ")}
          </Text>

          <Text fontSize="14px" color="t.80" mb="10px" fontWeight={"400"}>
            {t("wINMfXpJczhYZOnUXWp")}
          </Text>

          <MiliCodeInput
            ref={passWordInputRef}
            onChange={passwordInput}
            type="password"
            codeboxItemADDClassName="changeBackGround"
          />
          {codeError && (
            <Text color="red.100" fontSize="12px" mt="5px">
              {t("wINMfXpJczhYZOnUXWp")}
            </Text>
          )}
          <Flex justifyContent={"center"} mt="40px">
            <Button
              borderRadius={"20px"}
              w="100%"
              h="44px"
              fontSize="14px"
              color="#fff"
              // mt="50px"
              onClick={submitLogin}
              _hover={{ bg: code?.length === 6 ? "blue.80" : "t,50" }}
              cursor={code?.length === 6 ? "pointer" : "not-allowed"}
              bg={code?.length === 6 ? "blue.100" : "t.50"}
            >
              {t("YChcfaxDaLscdSPiRQz")}
            </Button>
          </Flex>
        </Box>
      </Flex>

      <PaymentPassModal
        show={showPaymentPassModal}
        onClose={() => {
          setShowPaymentPassModal(false);
        }}
        emailInfo={emailInfo}
        password={password}
        login={login}
      />
    </div>
  );
};

export default LoginAndRegisterBindGa;
